(() => {
  const STORAGE_KEY = 'tava-local-cart';

  function lang() {
    return document.documentElement.getAttribute('data-tava-lang') || 'ar';
  }

  function t(key) {
    const copy = {
      error: { ar: 'تعذّرت الإضافة إلى السلة.', en: 'Could not add to cart.' },
      added: { ar: 'تمت الإضافة إلى السلة ✓', en: 'Added to cart ✓' },
      order: { ar: 'اطلب الآن', en: 'Order now' },
      remove: { ar: 'إزالة', en: 'Remove' },
      removed: { ar: 'تمت إزالة المنتج', en: 'Item removed' },
    };
    const entry = copy[key];
    return (entry && (entry[lang()] || entry.ar)) || '';
  }

  function readLocalCart() {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeLocalCart(items) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('tava:cart-changed', { detail: { items } }));
  }

  function localCount() {
    return readLocalCart().reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
  }

  function addLocalItem(item) {
    const items = readLocalCart();
    const id = String(item.id);
    const existing = items.find((row) => String(row.id) === id);
    if (existing) {
      existing.quantity = (Number(existing.quantity) || 0) + (Number(item.quantity) || 1);
    } else {
      items.push({
        id,
        title: item.title || '',
        price: Number(item.price) || 0,
        image: item.image || '',
        url: item.url || '',
        quantity: Number(item.quantity) || 1,
      });
    }
    writeLocalCart(items);
    return items;
  }

  function removeLocalItem(id) {
    const next = readLocalCart().filter((row) => String(row.id) !== String(id));
    writeLocalCart(next);
    return next;
  }

  function itemFromButton(button, variantId) {
    const form = button?.closest('form') || button?.closest('[data-tava-cart-form]');
    const card = button?.closest('.card-wrapper, .product, product-info, .product__info-container');
    const title =
      button?.getAttribute('data-tava-title') ||
      card?.querySelector('.card__heading, .product__title, h1')?.textContent?.trim() ||
      '';
    const image =
      button?.getAttribute('data-tava-image') ||
      card?.querySelector('img')?.currentSrc ||
      card?.querySelector('img')?.src ||
      '';
    const url = button?.getAttribute('data-tava-url') || card?.querySelector('a[href*="/products/"]')?.href || '';
    const price = Number(button?.getAttribute('data-tava-price') || 0);
    const qty = Number(form?.querySelector('[name="quantity"]')?.value || 1) || 1;
    return { id: String(variantId), title, price, image, url, quantity: qty };
  }

  function injectToastStyles() {
    if (document.getElementById('tava-cart-toast-styles')) return;
    const style = document.createElement('style');
    style.id = 'tava-cart-toast-styles';
    style.textContent = `
      #tava-cart-toast {
        position: fixed;
        bottom: 24px;
        left: 50%;
        transform: translateX(-50%) translateY(20px);
        z-index: 99999;
        padding: 14px 24px;
        border-radius: 999px;
        background: #033840;
        color: #fff;
        font-size: 15px;
        font-weight: 700;
        box-shadow: 0 12px 32px rgba(3, 40, 46, 0.4);
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.25s ease, transform 0.25s ease;
      }
      #tava-cart-toast.is-visible {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
      }
      .tava-card-cart-icon.loading,
      .tava-add-to-cart-btn.loading { opacity: 0.7; pointer-events: none; }
    `;
    document.head.appendChild(style);
  }

  function showToast(message) {
    injectToastStyles();
    let toast = document.getElementById('tava-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'tava-cart-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(showToast._timer);
    showToast._timer = setTimeout(() => toast.classList.remove('is-visible'), 3000);
  }

  function getCartEl() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function setLoading(button, on) {
    if (!button) return;
    button.disabled = !!on;
    button.classList.toggle('loading', !!on);
    button.setAttribute('aria-busy', on ? 'true' : 'false');
    const spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !on);
  }

  function updateBubble(count) {
    const link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    let wrap = link.querySelector('.cart-count-bubble');
    if (!wrap && count > 0) {
      wrap = document.createElement('div');
      wrap.className = 'cart-count-bubble';
      const visible = document.createElement('span');
      visible.setAttribute('aria-hidden', 'true');
      const hidden = document.createElement('span');
      hidden.className = 'visually-hidden';
      wrap.appendChild(visible);
      wrap.appendChild(hidden);
      link.appendChild(wrap);
    }
    if (!wrap) return;
    const span = wrap.querySelector('[aria-hidden="true"]');
    if (span) span.textContent = count > 0 && count < 100 ? String(count) : count >= 100 ? '99+' : '';
    wrap.classList.toggle('hidden', count <= 0);
  }

  async function shopifyCount() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!res.ok) return 0;
      const cart = await res.json();
      return cart.item_count || 0;
    } catch (e) {
      return 0;
    }
  }

  async function refreshBubble() {
    const remote = await shopifyCount();
    updateBubble(remote > 0 ? remote : localCount());
  }

  async function fetchCartSections() {
    const ids = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
    const path = window.location.pathname || '/';
    const res = await fetch(`${path}?sections=${ids.join(',')}`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!res.ok) throw new Error('sections fetch failed');
    return res.json();
  }

  async function openCartNotification(cart, itemKey) {
    if (!cart) return false;
    try {
      const sections = await fetchCartSections();
      if (typeof cart.renderContents === 'function') {
        cart.renderContents({ key: itemKey, sections });
        return true;
      }
      if (typeof cart.open === 'function') {
        cart.open();
        return true;
      }
    } catch (e) {
      console.warn('TAVA cart notification:', e);
    }
    return false;
  }

  async function addViaJson(variantId, quantity) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: Number(variantId), quantity: quantity || 1 }),
    });

    let data = {};
    try {
      data = await res.json();
    } catch (e) {
      data = {};
    }

    if (!res.ok || data.status) {
      const err = new Error(data.description || data.message || 'sold out');
      err.status = res.status;
      err.payload = data;
      throw err;
    }

    return data;
  }

  async function addToCart(variantId, button) {
    if (!variantId) return;

    setLoading(button, true);
    const localItem = itemFromButton(button, variantId);

    try {
      const data = await addViaJson(variantId, localItem.quantity);
      await refreshBubble();
      showToast(t('added'));
      await openCartNotification(getCartEl(), data.key);
    } catch (err) {
      addLocalItem(localItem);
      await refreshBubble();
      showToast(t('added'));
      paintLocalCartPage();
    } finally {
      setLoading(button, false);
    }
  }

  function money(cents) {
    const value = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(lang() === 'ar' ? 'ar-SA' : 'en-SA', {
        style: 'currency',
        currency: 'SAR',
      }).format(value);
    } catch (e) {
      return `${value.toFixed(2)} SAR`;
    }
  }

  function enableCodForm() {
    document.querySelectorAll('[data-tava-cod-mode="cart"]').forEach((root) => {
      root.classList.remove('tava-cod--disabled');
      root.querySelectorAll('input, button, textarea').forEach((el) => {
        el.disabled = false;
      });
    });
  }

  function paintLocalCartPage() {
    const items = readLocalCart();
    const host = document.getElementById('tava-local-cart');
    if (!host) return;

    if (!items.length) {
      host.hidden = true;
      host.innerHTML = '';
      const order = document.getElementById('tava-cart-order');
      if (order && !document.querySelector('.cart-item')) order.hidden = true;
      const cartItems = document.querySelector('cart-items');
      if (cartItems && !document.querySelector('.cart-item')) {
        cartItems.classList.add('is-empty');
        cartItems.classList.remove('section-main-cart-items-padding');
      }
      const warnings = document.querySelector('.cart__warnings');
      if (warnings && !document.querySelector('.cart-item')) warnings.style.display = '';
      return;
    }

    const cartItems = document.querySelector('cart-items');
    if (cartItems) {
      cartItems.classList.remove('is-empty');
      cartItems.classList.add('section-main-cart-items-padding');
    }

    const warnings = document.querySelector('.cart__warnings');
    if (warnings) warnings.style.display = 'none';

    const order = document.getElementById('tava-cart-order');
    if (order) order.hidden = false;

    enableCodForm();

    const rows = items
      .map((item) => {
        const img = item.image
          ? `<img src="${item.image}" alt="" width="80" height="80">`
          : '';
        const href = item.url || '#';
        const id = String(item.id || '').replace(/"/g, '');
        return `
          <li class="tava-local-cart__row">
            <a class="tava-local-cart__media" href="${href}">${img}</a>
            <div class="tava-local-cart__info">
              <a href="${href}">${item.title || ''}</a>
              <span>${item.quantity} × ${money(item.price)}</span>
            </div>
            <strong>${money((item.price || 0) * (item.quantity || 1))}</strong>
            <button type="button" class="tava-local-cart__remove" data-tava-remove="${id}" aria-label="${t('remove')}">×</button>
          </li>
        `;
      })
      .join('');

    const total = items.reduce((sum, item) => sum + (Number(item.price) || 0) * (Number(item.quantity) || 0), 0);
    const count = localCount();
    host.hidden = false;
    host.innerHTML = `
      <ul class="tava-local-cart__list">${rows}</ul>
      <p class="tava-local-cart__total"><span>${count}</span> · <strong>${money(total)}</strong></p>
      <a href="#tava-cart-order" class="tava-cod__submit tava-cod__submit--direct tava-local-cart__order">
        ${t('order')}
      </a>
    `;

    const summary = document.querySelector('.tava-cart-checkout__summary');
    if (summary) {
      summary.hidden = false;
      summary.innerHTML = `<span>${count} · ${money(total)}</span>`;
    }
  }

  function handleAddClick(event, button) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    const form = button.closest('form');
    const variantId =
      button.getAttribute('data-tava-add') ||
      form?.querySelector('[name="id"]')?.value ||
      button.value;
    if (variantId) addToCart(variantId, button);
  }

  document.addEventListener('click', (event) => {
    const removeBtn = event.target.closest('[data-tava-remove]');
    if (removeBtn) {
      event.preventDefault();
      removeLocalItem(removeBtn.getAttribute('data-tava-remove'));
      paintLocalCartPage();
      refreshBubble();
      showToast(t('removed'));
      return;
    }

    const orderLink = event.target.closest('.tava-local-cart__order, .tava-cart-order-btn');
    if (!orderLink) return;
    const form = document.querySelector('#tava-cart-order [data-tava-cod-form], [data-tava-cod-form]');
    if (!form) return;
    event.preventDefault();
    document.getElementById('tava-cart-order')?.removeAttribute('hidden');
    form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    form.querySelector('input[name="customer_name"]')?.focus();
  });

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('[data-tava-add], .tava-card-cart-icon[data-tava-add]');
      if (!button || button.disabled) return;
      handleAddClick(event, button);
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest('[data-tava-cart-form], form[data-type="add-to-cart-form"]');
      if (!form) return;
      const button = form.querySelector('[data-tava-add], [type="submit"]');
      if (button?.hasAttribute('data-tava-add')) {
        handleAddClick(event, button);
      }
    },
    true
  );

  window.tavaCart = {
    read: readLocalCart,
    count: localCount,
    add: addLocalItem,
    remove: removeLocalItem,
    clear() {
      writeLocalCart([]);
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      injectToastStyles();
      refreshBubble();
      paintLocalCartPage();
    });
  } else {
    injectToastStyles();
    refreshBubble();
    paintLocalCartPage();
  }
})();
